import { render } from "./ScoreCounter.vue?vue&type=template&id=2dcd4a1d&scoped=true&ts=true"
import script from "./ScoreCounter.vue?vue&type=script&lang=ts"
export * from "./ScoreCounter.vue?vue&type=script&lang=ts"

import "./ScoreCounter.vue?vue&type=style&index=0&id=2dcd4a1d&scoped=true&lang=scss"

import exportComponent from "/tmp/plasty-fe-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcd4a1d"]])

export default __exports__